export default __webpack_public_path__ + "static/media/landlord.ab49fe44.jpg";